<template>
  <v-card id="lead-attach-policy-list">
    <v-card-text class="d-flex align-center lead-appbar-color flex-wrap pb-0">
      <h2
        style="color: white !important;"
        class="mb-4"
      >
        Draft leads
      </h2>
      <v-spacer></v-spacer>
      <div class="d-flex align-center pb-5">
        <!-- search request -->
        <v-tooltip
          :left="$vuetify.breakpoint.smAndUp"
          :top="$vuetify.breakpoint.xsOnly"
          :nudge-bottom="$vuetify.breakpoint.smAndUp ? 20 : 0"
          :nudge-top="$vuetify.breakpoint.xsOnly ? 5 : 0"
          :nudge-right="$vuetify.breakpoint.xsOnly ? 100 : 0"
          max-width="250"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              size="30"
              class="mr-3 hover-pointer"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                color="white"
                size="25"
              >
                {{ icons.mdiAlertCircleOutline }}
              </v-icon>
            </v-avatar>
          </template>
          <h3 class="my-2">
            {{ t('How to use the search bar') }}
          </h3>
          <p class="mb-1">
            {{ t('You can search using') }}:
          </p>
          <ul class="mb-2">
            <li>
              {{ t('Car Registration No.') }}
            </li>
            <li>
              {{ t('Customer Name') }}
            </li>
            <li v-if="userTeam !== 'Quotation Main Lead' && userTeam !== 'Quotation Assistant'">
              {{ t('Contact No.') }}
            </li>
          </ul>
        </v-tooltip>
        <v-text-field
          v-model="searchText"
          :append-icon="icons.mdiMagnify"
          single-line
          dense
          outlined
          hide-details
          :placeholder="t('Search Lead')"
          class="lead-appbar-item"
        ></v-text-field>
      </div>
    </v-card-text>
    <v-divider></v-divider>

    <!-- table -->
    <v-data-table
      :headers="userTeam === 'Quotation Assistant' ? issueHideTableColumns : issueTableColumns"
      :items="leads"
      :items-per-page="100"
      :loading="loading"
      hide-default-footer
      :disable-sort="true"
      mobile-breakpoint="0"
      class="text-no-wrap"
    >
      <!-- Actions -->
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center">
          <!-- Void -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-if="item.created_by_id === userData.id || userData.role === 'Auditor'"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="voidableLead = item; isVoidDialogVisible = true"
              >
                <v-icon size="18">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Void</span>
          </v-tooltip>

          <!-- View Previous Policy -->
          <v-tooltip
            v-if="item.previous_policy_url !== 'NULL'"
            bottom
          >
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :href="item.previous_policy_url"
                target="_blank"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiFileDocument }}
                </v-icon>
              </v-btn>
            </template>
            <span>View previous policy</span>
          </v-tooltip>
          <v-tooltip
            v-else
            bottom
          >
            <template #activator="{ on }">
              <div v-on="on">
                <v-btn
                  icon
                  small
                  disabled
                >
                  <v-icon size="18">
                    {{ icons.mdiHelpCircleOutline }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <span>No previous policy attached</span>
          </v-tooltip>

          <!-- Issue Receipt -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-if="userRole === 'Clerk' || userRole === 'SPD reporter'"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="goToReceiptAdd(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiReceipt }}
                </v-icon>
              </v-btn>
            </template>
            <span>Issue Receipt</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <!-- Void dialog -->
    <v-dialog
      v-model="isVoidDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title
          v-if="voidableLead"
          class="d-flex align-center mv-4"
        >
          Void lead for {{ voidableLead.name }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isVoidDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          This lead will be voided. It won't be taken into any calculations.
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            block
            :loading="voidLoading"
            :disabled="voidLoading"
            class="mt-3"
            @click="voidLead()"
          >
            Yes, remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text class="pt-5">
      <v-row>
        <v-col
          lg="2"
          cols="3"
        >
          <div class="d-flex align-center">
            <v-select
              v-model="tablePagination.per"
              :items="listLengthOptions"
              single-line
              outlined
              dense
              hide-details
              class="lead-list-row-selection"
              @input="listLengthChange()"
            ></v-select>
            <div class="pl-3">
              {{ t('Rows') }}
            </div>
          </div>
        </v-col>

        <v-col
          lg="10"
          cols="9"
          class="d-flex justify-end"
        >
          <v-pagination
            v-model="tablePagination.current_page"
            total-visible="6"
            :length="tablePagination.total_page"
            @input="pageChange()"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiPencilOutline,
  mdiDeleteOutline,
  mdiAlertCircleOutline,
  mdiMagnify,
  mdiEyeOutline,
  mdiClose,
  mdiFileDocumentOutline,
  mdiFileDocument,
  mdiHelpCircleOutline,
  mdiReceipt,
} from '@mdi/js'
import {
  onMounted,
  onUnmounted,
  ref,
  inject,
  watch,
  computed,
} from '@vue/composition-api'
import { useRouter } from '@core/utils'

// import notificationService from '@/services/notification.service'
import leadStoreModule from './leadStoreModule'
import receiptStoreModule from '../receipt/receiptStoreModule'

export default {
  setup() {
    // Initializers
    const store = inject('store')
    const snackbarService = inject('snackbarService')
    const t = inject('t')
    const can = inject('can')
    const { router } = useRouter()
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userRole = userData && userData.role ? userData.role : null

    const LEAD_APP_STORE_MODULE_NAME = 'app-lead'
    const RECEIPT_APP_STORE_MODULE_NAME = 'app-receipt'

    if (!store.hasModule(LEAD_APP_STORE_MODULE_NAME)) {
      store.registerModule(LEAD_APP_STORE_MODULE_NAME, leadStoreModule)
    }

    if (!store.hasModule(RECEIPT_APP_STORE_MODULE_NAME)) {
      store.registerModule(RECEIPT_APP_STORE_MODULE_NAME, receiptStoreModule)
    }

    // Table Handlers
    const issueTableColumns = computed(() => (
      [
        { text: t('Actions'), value: 'actions' },
        { text: t('Date Issued'), value: 'created_at' },
        ...(['Auditor', 'Secretary'].includes(userRole)
          ? [{ text: t('Quoted By'), value: 'quoted_by_name' }]
          : []
        ),
        { text: t('Name'), value: 'name' },
        { text: t('Contact No.'), value: 'contact_number' },
        { text: t('Car No.'), value: 'car_registration_number' },
        { text: t('Total'), value: 'total' },
        { text: t('Remarks'), value: 'remarks' },
      ]
    ))
    const issueHideTableColumns = computed(() => (
      [
        { text: t('Actions'), value: 'actions' },
        { text: t('Date Issued'), value: 'created_at' },
        ...(['Auditor', 'Secretary'].includes(userRole)
          ? [{ text: t('Quoted By'), value: 'quoted_by_name' }]
          : []
        ),
        { text: t('Name'), value: 'name' },
        { text: t('Car No.'), value: 'car_registration_number' },
        { text: t('Total'), value: 'total' },
        { text: t('Remarks'), value: 'remarks' },
      ]
    ))

    // Properties
    const leads = ref([])
    const tablePagination = ref({
      current_page: 1,
      per: 20,
      total_count: 0,
      total_page: 0,
    })
    const listLengthOptions = ref([5, 10, 20])
    const loading = ref(false)
    const isVoidDialogVisible = ref(false)
    const voidableLead = ref({})
    const voidLoading = ref(false)
    const searchText = ref('')
    const userTeam = computed(() => store.state.user.team)

    // const appCable = notificationService.webSocketConnection()

    // Methods
    const isLoading = () => {
      loading.value = true
      snackbarService.info('Loading your list. Please hold...')
    }
    const doneLoading = () => {
      loading.value = false
      snackbarService.success('Done loading your list!')
    }
    const fetchLeadCounts = () => {
      store
        .dispatch('fetchLeadCounts')
        .then(response => {
          const { data } = response.data
          store.dispatch('setLeadCounts', data)
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching lead counts. Please refresh!')
        })
    }
    const fetchLeads = () => {
      store
        .dispatch('app-lead/fetchLeads', {
          page: tablePagination.value.current_page,
          per: tablePagination.value.per,
          search_text: searchText.value,
          status: ['Attach Policy'],
        })
        .then(response => {
          const { data, pagination } = response.data
          leads.value = data
          leads.value.forEach(field => {
            Object.keys(field).forEach(key => {
              if (field[key] === null) field[key] = 'NULL'
            })
          })
          tablePagination.value = pagination
          doneLoading()
        })
        .catch(error => {
          loading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching leads. Please refresh!')
        })
    }
    const voidLead = () => {
      voidLoading.value = true
      store
        .dispatch('app-lead/voidLead', { id: voidableLead.value.id })
        .then(response => {
          snackbarService.success(response.data.message)
          fetchLeads()
          isVoidDialogVisible.value = false
          voidLoading.value = false
        })
        .catch(error => {
          voidLoading.value = false
          snackbarService.error(error.data.message || 'Something went wrong while voiding lead. Please refresh!')
        })
    }
    const pageChange = () => {
      isLoading()
      fetchLeads()
    }
    const listLengthChange = () => {
      tablePagination.value.current_page = 1
      isLoading()
      fetchLeads()
    }
    const goToReceiptAdd = id => {
      router.push({
        name: 'apps-receipt-add',
        params: { lead_id: id },
      })
    }

    /*
    const updateLeads = () => {
      appCable.subscriptions.create({
        channel: 'LeadChannel',
      },
      {
        connected() {
          console.log('Connected to the leads channel')
        },
        received(data) {
          switch (data.event) {
            case 'new_lead':
              fetchLeads()
              fetchLeadCounts()
              break
            case 'quoted_lead':
              fetchLeads()
              fetchLeadCounts()
              break
            case 'refresh_leads':
              fetchLeads()
              fetchLeadCounts()
              break
            case 'issue_lead':
              fetchLeads()
              fetchLeadCounts()
              break
            default:
          }
        },
        disconnected() {
          console.log('Disconnected from leads channel')
        },
      })
    }
    */

    let timer = null
    watch([searchText], () => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(() => {
        isLoading()
        fetchLeads()
      }, 200)
    })

    // Mounted
    onMounted(() => {
      fetchLeads()
      setTimeout(() => { fetchLeadCounts() }, 200)

      // updateLeads()
    })

    // Unmounted
    onUnmounted(() => {
      if (store.hasModule(LEAD_APP_STORE_MODULE_NAME)) store.unregisterModule(LEAD_APP_STORE_MODULE_NAME)
      if (store.hasModule(RECEIPT_APP_STORE_MODULE_NAME)) store.unregisterModule(RECEIPT_APP_STORE_MODULE_NAME)
    })

    return {
      t,
      can,
      userData,
      userTeam,
      userRole,
      leads,
      loading,
      tablePagination,
      listLengthOptions,
      issueTableColumns,
      issueHideTableColumns,
      listLengthChange,
      pageChange,
      voidLead,
      isVoidDialogVisible,
      voidLoading,
      voidableLead,
      searchText,
      goToReceiptAdd,

      icons: {
        mdiPencilOutline,
        mdiDeleteOutline,
        mdiAlertCircleOutline,
        mdiMagnify,
        mdiEyeOutline,
        mdiClose,
        mdiFileDocumentOutline,
        mdiFileDocument,
        mdiHelpCircleOutline,
        mdiReceipt,
      },
    }
  },
}
</script>

<style lang="scss">
#lead-attach-policy-list {
  .lead-list-row-selection {
    max-width: 5.3rem;
  }
  .lead-appbar-item {
    max-width: 12.2rem;
  }
  .lead-appbar-color {
    background-color: #3f1474;
  }
  .v-input.lead-appbar-item {
    background-color: white !important;
  }
  .theme--dark.lead-appbar-item input::placeholder,
  .theme--dark.lead-appbar-item .v-icon {
    color: #928C99 !important;
  }
}
</style>
